// shows a modal once for the user, and never shows it again, even across reloads, etc.
// expects props:
// - headerText (modal title)
// - children (modal content)
// - tourName (the name of the tour to use - unique per modal/tour type)
// - location url (IMPORTANT: this will force the component to re-rerender and refetch the tour status if the page changes)

import { Component } from "react";
import { graphql } from "@apollo/client/react/hoc";
import { Modal, Button } from "semantic-ui-react";

import TourQuery from "common/queries/Tour";

class OneOffModal extends Component {
  constructor(props) {
    super(props);

    this.state = { open: true };
  }

  close() {
    this.setState({ open: false });
  }

  render() {
    // don't show the modal if the employer has already viewed it
    // slight hack: we pass location to the intro modal component to force it to rerender (and therefore refetch the tour status)
    const { data, headerText, children } = this.props;
    if (data.loading || !data.view_tour) {
      return null;
    }

    return (
      <Modal
        open={this.state.open}
        size="small"
        onClose={this.close.bind(this)}
      >
        <Modal.Header>{headerText}</Modal.Header>
        <Modal.Content>{children}</Modal.Content>
        <Modal.Actions>
          <Button onClick={this.close.bind(this)} primary>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const Query = graphql(TourQuery, {
  options: ({ tourName }) => ({
    variables: {
      tourName,
    },
    fetchPolicy: "network-only", // tour should be viewed after the first time. force refresh to make sure we don't show it twice
  }),
});

export default Query(OneOffModal);
